<header></header>
<div class="post-login-2">
    <div class="post-login-2-col-1 h-100">
        <app-left-panel-prelogin activeTab="2" *ngIf="this.auth?.detailuser == undefined"></app-left-panel-prelogin>
        <left-panel activeTab="2" *ngIf="this.auth?.detailuser != undefined"></left-panel>
    </div>
    <div class="post-login-2-col-2 has-banner">
    </div>
    <div class="post-login-2-col-3 bg-base-100 p-mobile-15 h-100 pt-70-pb-70-pr-40">
        <div class="onboarding-canvas h-100">
            <grid-row class="justify-content-center align-content-between pb-30 h-100">
                <grid-col col="12">
                    <!-- <div class="font-400 font-size-20px line-h-25">
                        {{ "SetPermanentLimit" | translate }}
                    </div> -->
                    <div class="font-400 font-size-20px line-h-25"> 
                        {{ "SetNewTemporaryLimit" | translate }}
                    </div>
                    <div class="font-400 font-size-14px color-base-400 mt-10 line-h-20">
                        {{ "PleaseCardLimit" | translate }}
                      </div>
                      <!-- <div class="font-400 font-size-14px color-base-400 mt-10 line-h-20">
                        {{ "PleaseEnterTemporaryLimit" | translate }}
                      </div> -->
                </grid-col>
                <grid-col col="12" >
                    <div class="form-group mt-30">
                        <label>
                            {{ "EnterDesiredAmount" | translate }}
                        </label>
                        <div class="has-absolute-layer-left mt-10">
                            <span class="absolute-layer-left desire">
                                {{"BHD" | translate}}
                            </span>
                            <!-- <input type="text" class="desire-amount icon-edit" value="{{this.minmum| amountFormatter}}" readonly  *ngIf="this.minmumValue == this.requestedLimit"> -->
                            <!-- <input type="text" class="desire-amount icon-edit" value="{{this.minmumValue}}" readonly *ngIf="this.minmumValue != this.requestedLimit">  -->
                            <input type="text" class="desire-amount icon-edit" (change)="valueChange($event.target.value)" value="{{this.minmum | amountFormatter}}"> 

                        </div>
                    </div>
                    <div class="custom-range-2 mt-24">
                        <!-- [(highValue)]="this.highValue" -->
                        <ngx-slider [(value)]="this.minmumValue"  (valueChange)="valueChange($event)"  [options]="this.options" ></ngx-slider>

                    </div>
                </grid-col>
                <grid-col col="12">
                    <grid-row class="justify-content-between align-item-center mt-50">
                        <grid-col col="auto">
                            <div class="mt-15">
                                <button class="btn-back" (click)="back()">
                                    <i class="icon-back"></i>
                                </button>
                            </div>
                        </grid-col>
                        <grid-col col="9">
                            <button class="btn-dft" [disabled]="Valid()" (click)="SaveNewLimit()">
                                {{ "NEXT" | translate }}
                            </button>
                        </grid-col>
                    </grid-row>
                </grid-col>
            </grid-row>
          
           
          
        </div>
    </div>
</div>


<!-- Change Card -->
<modal modalID="2" [events]="modalObservable.asObservable()" [backdropDismiss]="false" modalDoneButtonText="CONFIRM"
    [whiteButtonStatus]="true" whiteButtonText="cancel" (doneButton)="cardUploadDocument()">
    <div class="text-align-center">
        <ng-icon iconClass="icon-card-limit" width="77" height="72"></ng-icon>
        <div class="font-size-20px color-base-1300 font-400 line-h-25 mt-30 letter-spacing-03">
            {{"SetNewLimit" | translate}}
        </div>
        <!-- <div class="mt-10">
            <span class="font-400 line-h-25 color-base-500">
                {{"YouwantCardLimit" | translate}} 
            </span>
            <strong class="color-base-700 line-h-25">
                {{"BHD" | translate}} 500.000 
            </strong>
            <span class="font-400 line-h-25 color-base-500">
               ?
            </span>
        </div> -->
        <!-- <div class="mt-10">
            <span class="font-400 line-h-25 color-base-500">
                {{"SureWantIncreaseLimit" | translate}} 
            </span>
            <strong class="color-base-700 line-h-25">
            {{"BHD" | translate}} 10.000?
            </strong>
        </div> -->
        <div class="mt-10">
            <span class="font-400 line-h-25 color-base-500">
                {{"SureWantDecrease" | translate}} 
            </span>
            <strong class="color-base-700 line-h-25">
            {{"BHD" | translate}} {{this.minmum | amountFormatter}}?
            </strong>
        </div>
        <div class="mt-10">
            <span class="font-400 line-h-25 color-base-500">
                {{"ByTappingConfirm" | translate}} 
            </span>
            <strong class="color-base-2200 line-h-25">
            {{"TermsConditions" | translate}}
            </strong>
            <span class="font-400 line-h-25 color-base-500">
                {{"Applicable" | translate}}
            </span>
        </div>
    </div>
</modal>